  class SortByCustom extends HTMLElement {
    constructor() {
      super();
      this.handleClick = this.handleClick.bind(this);
      this.handleScroll = this.handleScroll.bind(this);
    }

    connectedCallback() {
      this.button = this.querySelector('button');
      if (this.button) {
        this.button.addEventListener('click', this.handleClick);
      }
      window.addEventListener('scroll', this.handleScroll);
    }

    disconnectedCallback() {
      if (this.button) {
        this.button.removeEventListener('click', this.handleClick);
      }
      window.removeEventListener('scroll', this.handleScroll);
    }

    handleClick(event) {
      event.preventDefault(); // prevent form submission
      this.classList.toggle('active');
    }

    handleScroll() {
      if (this.classList.contains('active')) {
        this.classList.remove('active');
      }
    }
  }

  customElements.define('sort-by-custom', SortByCustom);